export default function () {
    init();
}

function init() {
    const dropdowns = document.querySelectorAll(".js-dropdown");
    dropdowns.forEach(function (dropdown) {
        const dd = new PBCustomDropdown(dropdown, {});
        dropdown.pbCustomDropdown = dd;
    });
}

function PBCustomDropdown(wrapperEl, options = {}) {
  this.options = {
    defaultLabel: "DEFAULT LABEL",
    hoverClass: "isHover",
    activeClass: "isActive",
    submitForm: Object.keys(wrapperEl.dataset).includes("submit"),
    ...options,
  };

  this.els = {
    wrapper: wrapperEl,
    nativeSelect: wrapperEl.querySelector(".js-selectNative"),
    customSelect: wrapperEl.querySelector(".js-selectCustom"),
    customSelectBox: null,
    customSelectOptions: null,
    customOptsList: [],
    form: null,
  };

  this.state = {
    optionHoveredIndex: -1,
    optionChecked: "",
    optionsCount: 0,
    selectedIndex: 0,
  };

  const self = this;

  this.init = function () {
    if (!self.els.wrapper) return;

    if (self.options.submitForm) {
      self.els.form = self.els.wrapper.closest("form");
    }

    self.state.selectedIndex = Array.prototype.slice
      .call(self.els.nativeSelect.children)
      .reduce(function (acc, curr, currIdx) {
        if (curr.selected) {
          return currIdx;
        }
        return acc;
      }, 0);

    self.createCustomSelect();
    self.addListeners();
  };

  this.updateSelectOptions = function () {
    // Clear current options
    self.els.customSelectOptions.innerHTML = "";

    // Add options based on select list
    Array.from(self.els.nativeSelect.children).forEach(function (el) {
      const opt = document.createElement("div");
      opt.classList.add("select-custom-option");

      opt.dataset.value = el.value;
      self.setDatasetProps(el.dataset, opt);

      opt.textContent = el.textContent;
      self.els.customSelectOptions.appendChild(opt);
    });

    // Update stored elements & state
    self.els.customOptsList = Array.from(self.els.customSelectOptions.children);
    self.state.optionsCount = self.els.customOptsList.length;

    // Set initial text as first option text
    self.els.customSelectBox.textContent =
      self.els.nativeSelect.children[self.state.selectedIndex].textContent;

    self.setDatasetProps(
      self.els.nativeSelect.children[self.state.selectedIndex].dataset,
      self.els.customSelectBox
    );

    this.addCustomOptionListeners();
  };

  this.createCustomSelect = function () {
    // Create custom select box from native select options
    const customSelect = document.createElement("div");
    customSelect.classList.add("select-custom");
    customSelect.setAttribute("aria-hidden", true);

    const customTrigger = document.createElement("div");
    customTrigger.classList.add("select-custom-trigger");

    const customOptions = document.createElement("div");
    customOptions.classList.add("select-custom-options");

    customSelect.appendChild(customTrigger);
    customSelect.appendChild(customOptions);

    self.els.wrapper.children[0].appendChild(customSelect);
    self.els.customSelect = customSelect;
    self.els.customSelectBox = customTrigger;
    self.els.customSelectOptions = customOptions;

    self.updateSelectOptions();
  };

  this.addListeners = function () {
    // Toggle custom select visibility when clicking the box
    self.els.customSelectBox.addEventListener("click", function (e) {
      const isClosed = !self.els.customSelect.classList.contains(
        self.options.activeClass
      );

      if (isClosed) {
        self.openSelectCustom();
      } else {
        self.closeSelectCustom();
      }
    });
    document.addEventListener("click", self.watchClickOutside);
  };

  this.addCustomOptionListeners = function () {
    // Update selectCustom value when an option is clicked or hovered
    self.els.customOptsList.forEach(function (elOption, index) {
      elOption.addEventListener("click", function (e) {
        const value = e.target.getAttribute("data-value");

        // Sync native select to have the same value
        self.els.nativeSelect.value = value;
        self.updateCustomSelectChecked(
          value,
          e.target.textContent,
          e.target.dataset
        );
        self.closeSelectCustom();

        self.submitForm();
      });

      elOption.addEventListener("mouseenter", function (e) {
        self.updateCustomSelectHovered(index);
      });
    });
  };

  this.submitForm = function () {
    if (self.options.submitForm) {
      self.els.form.submit();
    }
  };

  this.openSelectCustom = function () {
    self.els.customSelect.classList.add(self.options.activeClass);
    // Remove aria-hidden in case this was opened by a user
    // who uses AT (e.g. Screen Reader) and a mouse at the same time.
    self.els.customSelect.setAttribute("aria-hidden", false);

    if (self.state.optionChecked) {
      const optionCheckedIndex = self.els.customOptsList.findIndex(
        (el) => el.getAttribute("data-value") === self.state.optionChecked
      );
      self.updateCustomSelectHovered(optionCheckedIndex);
    }

    // Add related event listeners
    // Remove initial listener
    document.removeEventListener("click", self.watchClickOutside);

    document.addEventListener("click", self.watchClickOutside);
    document.addEventListener("keydown", self.supportKeyboardNavigation);
  };

  this.closeSelectCustom = function () {
    self.els.customSelect.classList.remove(self.options.activeClass);

    self.els.customSelect.setAttribute("aria-hidden", true);

    self.updateCustomSelectHovered(-1);

    // Remove related event listeners
    document.removeEventListener("click", self.watchClickOutside);
    document.removeEventListener("keydown", self.supportKeyboardNavigation);
  };

  this.updateCustomSelectHovered = function (newIndex) {
    const prevOption =
      self.els.customSelectOptions.children[self.state.optionHoveredIndex];
    const option = self.els.customSelectOptions.children[newIndex];

    if (prevOption) {
      prevOption.classList.remove(self.options.hoverClass);
    }
    if (option) {
      option.classList.add(self.options.hoverClass);
    }

    self.state.optionHoveredIndex = newIndex;
  };

  this.updateCustomSelectChecked = function (value, text, optDataset) {
    const prevValue = self.state.optionChecked;

    const elPrevOption = self.els.customSelectOptions.querySelector(
      `[data-value="${prevValue}"]`
    );
    const elOption = self.els.customSelectOptions.querySelector(
      `[data-value="${value}"]`
    );

    if (elPrevOption) {
      elPrevOption.classList.remove(self.options.activeClass);
    }

    if (elOption) {
      elOption.classList.add(self.options.activeClass);
    }

    self.els.customSelectBox.textContent = text;
    self.setDatasetProps(optDataset, self.els.customSelectBox);

    self.els.customSelectBox.textContent = text;
    self.state.optionChecked = value;

    // Fire change event manually
    var event = new Event("change");
    event.value = value;
    self.els.nativeSelect.dispatchEvent(event);

    self.submitForm();
  };

  this.watchClickOutside = function (e) {
    const didClickedOutside = !self.els.customSelect.contains(e.target);
    if (didClickedOutside) {
      self.closeSelectCustom();
    }
  };

  this.supportKeyboardNavigation = function (e) {
    // press down -> go next
    if (
      e.keyCode === 40 &&
      self.state.optionHoveredIndex < self.state.optionsCount - 1
    ) {
      let index = self.state.optionHoveredIndex;
      e.preventDefault(); // prevent page scrolling
      self.updateCustomSelectHovered(self.state.optionHoveredIndex + 1);
    }

    // press up -> go previous
    if (e.keyCode === 38 && self.state.optionHoveredIndex > 0) {
      e.preventDefault(); // prevent page scrolling
      self.updateCustomSelectHovered(self.state.optionHoveredIndex - 1);
    }

    // press Enter or space -> select the option
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();

      const option =
        self.els.customSelectOptions.children[self.state.optionHoveredIndex];
      const value = option && option.getAttribute("data-value");

      if (value) {
        self.els.nativeSelect.value = value;
        self.updateCustomSelectChecked(
          value,
          option.textContent,
          option.dataset
        );
      }
      self.closeSelectCustom();
    }

    // press ESC -> close selectCustom
    if (e.keyCode === 27) {
      self.closeSelectCustom();
    }
  };

  this.setDatasetProps = function (optDataset, targetEl) {
    const optDatasetArr = Object.entries(optDataset);
    for (let i = 0; i < optDatasetArr.length; i++) {
      const key = optDatasetArr[i][0];
      const val = optDatasetArr[i][1];
      targetEl.dataset[key] = val;
    }
  };

  this.init();
}
